import React from 'react'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom';

const CategoryList = props => {
    if (!props.categories) {
        return (
          <div className='broad'>Loading...</div>
        );
    }

    if (props.categories.length === 0) {
        return (
            <div className='empty'>
                No categories...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>Key</th>
                        <th>Name</th>
                        <th>User Key</th>
                        <th>Created</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.categories.map(item => {
                            return (
                                <tr key={item.key}>
                                    <td className="keyfield"><Link to={`/category/${item.key}/detail`}>{item.key}</Link></td>
                                    <td>{item.name}</td>
                                    <td className="keyfield"><Link to={`/users/${item.userkey}`}>{item.userkey}</Link></td>
                                    <td>{dateHelper.Formatter.toLocalString(item.created)}</td>
                                    <td className="keyfield"><Link to={`/category/${item.key}/edit`}>Edit</Link></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default CategoryList;



// WEBPACK FOOTER //
// ./src/components/widgets/CategoryList.js